import { Dispatch } from 'redux';
import { axiosInstance } from '../../../helpers/axiosInstance';
import { currentSubscriptionUrl } from '@pisaka/core/endpointUrls/endpointUrls';
import {
  setCurrentSubscriptionAction,
  setSubscriptionLoadingAction,
  setSubscriptionErrorAction,
} from './actions';

export const fetchCurrentSubscription = (token: string) => async (dispatch: Dispatch) => {
  try {
    dispatch(setSubscriptionLoadingAction(true));

    const response = await axiosInstance(token).get(currentSubscriptionUrl);

    dispatch(setCurrentSubscriptionAction(
      response.data.subscription || null,
      response.data.hasSubscription || false
    ));
  } catch (err: any) {
    console.error('Error fetching current subscription:', err);
    dispatch(setSubscriptionErrorAction(
      err.response?.data?.error?.message || 'Не удалось загрузить подписку'
    ));
    // При ошибке устанавливаем подписку как отсутствующую
    dispatch(setCurrentSubscriptionAction(null, false));
  }
};